import { EditorExtensionSDK } from '@contentful/app-sdk';

let ctfAppSdk: EditorExtensionSDK | null = null;

export const getCtfAppSdk = () => ctfAppSdk;

export const setCtfAppSdk = (sdk: EditorExtensionSDK) => {
  ctfAppSdk = sdk;
};
